import React from "react";
import { bool, string, func, object, oneOfType } from "prop-types";
import { format, addDays } from 'date-fns';
import DatePicker from "react-datepicker";
import { GetIcon } from "../icons/GetIcon.js";

const DateFacets = (props) => {
  const { endDate, id, showLabel, startDate, handleUpdate } = props;

  let currentEndDate = endDate;
  let currentStartDate = startDate;

  const handleChangeStart = (date) => {
    currentStartDate = date;
  }

  const handleCloseStart = () => {
    const date = currentStartDate;
    const newStartDate = date instanceof Date ? format(new Date(date), "yyyy-MM-dd") : null;
    const newEndDate = endDate instanceof Date ? format(new Date(endDate), "yyyy-MM-dd") : null;

    handleUpdate({
      endDate: endDate,
      startDate: newEndDate && newStartDate > newEndDate ? newEndDate : newStartDate
    });
  }

  const handleChangeEnd = (date) => {
    currentEndDate = date;
  }

  const handleCloseEnd = () => {
    const date = currentEndDate;
    const newStartDate = startDate instanceof Date ? format(new Date(startDate), "yyyy-MM-dd") : null;
    const newEndDate = date instanceof Date ? format(new Date(date), "yyyy-MM-dd") : null;

    handleUpdate({
      endDate: newStartDate && newEndDate < newStartDate ? newStartDate : newEndDate,
      startDate: startDate
    })
  }

  // let minDate = !startDate || startDate === "*" ? "*" : new Date(startDate);
  // let maxDate = !endDate || endDate === "*" ? "*" : new Date(endDate);
  // not sure why we have to add a day here
  let selectedStart = startDate ? addDays(new Date(startDate), 1) : null;
  let selectedEnd = endDate ? addDays(new Date(endDate), 1) : null;

  return (
    <div className="facets__date">
      {showLabel && <div className="facets__date-visual-label">Date: </div>}
      <div className="form__field">
        <label htmlFor={id + "startfield"}>From <span className="visually-hidden">Date</span></label>
        <DatePicker
          dateFormat="M/d/yyyy"
          id={id + "startfield"}
          onChange={handleChangeStart}
          onCalendarClose={handleCloseStart}
          placeholderText="MM/DD/YYYY" 
          selected={selectedStart}
          enableTabLoop={false} />
        {GetIcon("calendar")}
      </div>
      <div className="form__field">
        <label htmlFor={id + "endfield"}>To <span className="visually-hidden">Date</span></label>
        <DatePicker
          dateFormat="M/d/yyyy"
          id={id + "endfield"}
          onChange={handleChangeEnd}
          onCalendarClose={handleCloseEnd}
          placeholderText="MM/DD/YYYY" 
          selected={selectedEnd}
          enableTabLoop={false} />
        {GetIcon("calendar")}
      </div>
    </div>
  );
}

DateFacets.propTypes = {
  endDate: oneOfType([object, string]),
  handleUpdate: func,
  id: string,
  startDate: oneOfType([object, string]),
  showLabel: bool
};

export default DateFacets;
